export const addPrivacyManager = (link: HTMLElement) => {
    window.cmpClient.cmd.push(() => {
        const cmpClient = window.getCmpClient();
        cmpClient.addPrivacyManager(link);
    });
};
